<template>
  <div class="contentHome">
    <div class="centerPage">
      <div class="login">
        <div class="leftBG">
          <strong>欢迎使用</strong>
          <h1>心理亦笙</h1>
          <div class="content">
            <span>① 输入用户名、手机号码等基本信息</span>
            <span>② 选择注册类型和开始行医时间</span>
            <span>③ 阅读并同意《医生用户注册协议》</span>
            <span>④ 上传头像</span>
            <span>⑤ 填写专业信息</span>
            <span>⑥ 上传专业资质凭证</span>
            <span>⑦ 设置登录密码</span>
            <span>⑧ 填写账户信息</span>
          </div>
          <strong>注册完成！</strong>
        </div>
        <div class="right">
          <span class="title">医生用户注册</span>
          <el-steps :active="active" align-center class="stepRes">
            <el-step v-for="(item,index) in titleList" :title="item.title" :key="index"></el-step>
          </el-steps>
          <el-form ref="form" class="doctorLogin registForm" :model="user" label-width="115px" label-suffix="：">
            <template v-if="active===0">
              <!-- vueCropper 剪裁图片实现-->


              <el-form-item label="">
                <span slot="label" class="required-field">用户名：</span>
                <el-input v-model="user.account" placeholder="用户名(4-16位、只能包含数字、字母)"></el-input>
              </el-form-item>
              <el-form-item label="">
                <span slot="label" class="required-field">手机号码：</span>
                <el-input v-model="user.mobile" type="tel" placeholder="手机号码"></el-input>
              </el-form-item>
              <el-form-item label="">
                <span slot="label" class="required-field">邮箱：</span>
                <el-input v-model="user.email" placeholder="邮箱"></el-input>
              </el-form-item>
              <el-form-item>
                <span slot="label" class="required-field">真实姓名：</span>
                <el-input v-model="user.fullName" placeholder="真实姓名"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-radio-group v-model="user.gender" class="sex">
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="">
                <span slot="label" class="required-field">注册类型：</span>
                <el-radio-group v-model="user.medicineType" class="sex">
                  <el-radio :label="1">咨询师</el-radio>
                  <el-radio :label="2">医生</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="">
                <span slot="label" class="required-field">开始行医时间：</span>
                <el-date-picker
                    v-model="user.startWorkFormDate"
                    type="date" style="width: 100%;"
                    placeholder="开始行医时间">
                </el-date-picker>
              </el-form-item>

            </template>
            <template v-else-if="active===1">
              <el-form-item>
                <span slot="label" class="">头像：</span>
                <el-upload
                    class="avatar-uploader"
                    :action="imgUploadUrl"
                    name="uploadFile"
                    :show-file-list="false"
                    :on-change='changeUpload'>
                  <!--                <img v-if="user.headImgPath" :src="user.headImgPath" class="avatar">-->
                  <el-image
                      v-if="user.headImgPath"
                      style="width: 56px; height: 62px"
                      :src="user.headImgPath"
                      fit="fill"></el-image>
                  <p v-else class="clickUp">
                    <img src="../../assets/img/ys.png" alt="" width="16" height="18">
                    <span>点击上传头像</span>
                  </p>
                </el-upload>
              </el-form-item>
              <el-form-item label="所在单位">
                <el-input v-model="user.company" placeholder="所在单位"></el-input>
              </el-form-item>
              <el-form-item label="科室">
                <el-input v-model="user.department" placeholder="科室"></el-input>
              </el-form-item>
              <el-form-item label="职位">
                <el-input v-model="user.job" placeholder="职位"></el-input>
              </el-form-item>
              <el-form-item label="专业擅长">
                <el-input v-model="user.skill" placeholder="专业擅长"></el-input>
              </el-form-item>
              <el-form-item label="签名">
                <el-input v-model="user.signature" placeholder="请写下您对到访者想说的话"></el-input>
              </el-form-item>
              <el-form-item label="医师执业证书">
                <div class="flex" style="justify-content: space-between">
                  <el-input v-model="user.certNo" placeholder="证书编号" style="width: 48%;"></el-input>
                  <el-date-picker style="width: 48%"
                                  v-model="user.certIssuedFormDate"
                                  type="date"
                                  placeholder="发证日期">
                  </el-date-picker>
                </div>
                <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl+'cert'"
                    name="uploadFile"
                    :show-file-list="false"
                    :on-success="handleCertSuccess">
                  <img v-if="user.certFilePath" :src="user.certFilePath" class="avatar">
                  <span v-else class="practiceImg"><img src="../../assets/img/uploadBOOK.png" alt=""
                                                        width="37">上传图片</span>
                </el-upload>
              </el-form-item>
              <el-form-item label="医师资格证书">
                <div class="flex" style="justify-content: space-between">
                  <el-input v-model="user.licenceNo" placeholder="证书编号"
                            style="width: 48%;"></el-input>
                  <el-date-picker style="width: 48%"
                                  v-model="user.licenceIssuedFormDate"
                                  type="date"
                                  placeholder="发证日期">
                  </el-date-picker>
                </div>
                <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl+'licence'"
                    name="uploadFile"
                    :show-file-list="false"
                    :on-success="handleLicenceSuccess">
                  <img v-if="user.licenceFilePath" :src="user.licenceFilePath" class="avatar">
                  <span v-else class="practiceImg"><img src="../../assets/img/uploadBOOK.png" alt=""
                                                        width="37">上传图片</span>
                </el-upload>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="">
                <span slot="label" class="required-field">登录密码：</span>
                <el-input type="password" v-model="user.password" placeholder="请输入登录密码（长度在6~18之间，只能包含字母、数字）"></el-input>
              </el-form-item>
              <el-form-item label="">
                <span slot="label" class="required-field">确认密码：</span>
                <el-input type="password" v-model="user.pwd" placeholder="确认密码"></el-input>
              </el-form-item>
              <el-form-item label="开户银行">
                <el-input v-model="user.bankName" placeholder="开户银行"></el-input>
              </el-form-item>
              <el-form-item label="开户名称">
                <el-input v-model="user.bankAccountName" placeholder="开户名称"></el-input>
              </el-form-item>
              <el-form-item label="银行账号">
                <el-input v-model="user.bankAccountNo" placeholder="银行账号"></el-input>
              </el-form-item>
              <el-form-item label="">
                <span slot="label" class="required-field">验证码：</span>
                <div class="flex elInput" style="width: 100%;">
                  <el-input type="text" v-model="vcode" placeholder="图形验证码"></el-input>
                  <div class="flex getCode" @click="reloadCode('vcode')" style="cursor: pointer;">
                    <img id="vcode" src="" alt="">
                  </div>
                </div>
              </el-form-item>
            </template>
            <el-checkbox v-model="isAgree" class="agreement">我已阅读并同意<a target="_blank" href="/agreement/doctor">《医生用户注册协议》</a>
            </el-checkbox>
            <div class="btnGroup flex">
              <el-button @click="prev" v-if="active!=0" class="prev">上一步</el-button>
              <el-button @click="validate1()" v-if="active==0" class="next">下一步</el-button>
              <el-button @click="validate2()" v-if="active==1" class="next">下一步</el-button>
              <el-button v-if="active==2" class="next" @click="onSubmit">提交</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
        :show-close="true"
        class="tips paySuccess"
        top="0"
        :visible.sync="dialogVisible"
        width="30%">
      <img src="../../assets/img/success.png" alt="" width="140">
      <p>提交成功，{{ user.fullName }}工作室已建立完成！</p>
      <div class="sub">
        <el-button @click="toSee()">去看看</el-button>
      </div>
    </el-dialog>

    <el-dialog title="图片剪裁" :visible.sync="dialogVisible1" :close-on-press-escape="false"
               :close-on-click-modal="false" append-to-body>
      <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <vueCropper
              ref="cropper"
              :img="option.img"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="true"
              :canScale="option.canScale"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :fixedBox="option.fixedBox"
              :fixed="option.fixed"
              :fixedNumber="option.fixedNumber"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :centerBox="option.centerBox"
              :infoTrue="option.infoTrue"
              :full="option.full"
              :enlarge="option.enlarge"
              :mode="option.mode">
          </vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取消</el-button>
        <el-button type="primary" @click="finish" :loading="loading1">确认</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import SysCons from '@/api/common';
import {Loading} from 'element-ui';

// 使用vue-cropper 图片上传组件
import {VueCropper} from 'vue-cropper';


export default {
  name: "doctorRegist",
  data() {
    return {
      imgUploadUrl: SysCons.headImgUploadUrl,// 头像上传地址
      uploadUrl: SysCons.uploadUrl,
      webUrl: SysCons.web_url,
      active: 0,
      titleList: [{
        title: '基本信息',
      }, {
        title: '专业资质',
      }, {
        title: '账户信息',
      }],
      vcode: '',
      user: {
        headImgPath: '',
        fullName: '',
        gender: 1,
        medicineType: 0,
        startWorkFormDate: '',
        skill: '',
        mobile: '',
        email: '',
        signature: '',
        account: '',
        company: '',
        department: '',
        job: '',
        certNo: '',
        certIssuedFormDate: '',
        certFilePath: '',
        licenceNo: '',
        licenceIssuedFormDate: '',
        licenceFilePath: '',
        bankName: '',
        bankAccountName: '',
        bankAccountNo: '',
        password: '',
        pwd: ''
      },
      dialogVisible: false,
      loading: false,
      fileImg: '',
      dialogVisible1: false,
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        info: true, // 裁剪框的大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 260, // 默认生成截图框宽度
        autoCropHeight: 260, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [260, 260], // 截图框的宽高比例
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: true, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
        full: false, // 是否输出原图比例的截图
        enlarge: '1', // 图片根据截图框输出比例倍数
        mode: 'contain' // 图片默认渲染方式
      },
      loading1: false,
      isAgree: false,


    }
  },
  inject: ['reload'],
  methods: {
    prev() {
      --this.active;
      if (this.active < 0) this.active = 0;
    },
    handleAvatarSuccess(res, file) {
      // this.user.headImgPath = URL.createObjectURL(file.raw);
      this.user.headImgPath = res.message;
    },
    handleCertSuccess(res, file) {
      // this.user.practiceImg = URL.createObjectURL(file.raw);
      this.user.certFilePath = res.message;
    },
    handleLicenceSuccess(res, file) {
      // this.user.qualificationsImg = URL.createObjectURL(file.raw);
      this.user.licenceFilePath = res.message;
    },
    onSubmit() {
      let vm = this;

      if (vm.user.password != vm.user.pwd) {
        vm.$message.error("两次密码输入不一致");
        vm.loading.close();
        return;
      }
      if (!SysCons.reg.pass.test(vm.user.password)) {
        vm.$message.error("密码不符合规范，长度在6~18之间，只能包含字母、数字");
        vm.loading.close();
        return;
      }
      if (vm.vcode.length == 0) {
        vm.$message.info('请先输入图形验证码');
        vm.loading.close();
        return false;
      }
      if (!vm.isAgree) {
        vm.$message.error("请先阅读医生用户注册协议");
        return;
      }
      let token = $('img#vcode').attr('key');
      vm.loading = Loading.service({target: '.registForm'});
      vm.$ajax.post(SysCons.api.doctor.regist + "?token=" + token + '&code=' + vm.vcode, vm.user)
          .then((res) => {
            if (res.data.status == 'success') {
              // vm.$message({
              //     type: 'success',
              //     message: '注册成功',
              //     onClose: () => {
              //         vm.$router.push('/login')
              //     }
              // })
              this.dialogVisible = true
            } else {
              vm.$message.error(res.data.message);
              vm.loading.close();
            }
          })
    },
    toSee() {
      let vm = this
      this.$router.push({path: '/' + vm.user.account})
    },
    async validate1() {
      let vm = this;
      /*
      if ($.trim(vm.user.headImgPath).length == 0) {
        vm.$message.warning("请先上传头像");
        return false;
      }
      */

      if ($.trim(vm.user.account).length == 0) {
        vm.$message.warning("用户名不能为空");
        return false;
      }
      if (!SysCons.reg.account.test($.trim(vm.user.account))) {
        vm.$message.warning("用户名不符合规范: 4-16位(只能包含数字、字母)");
        return false;
      }

      if ($.trim(vm.user.mobile).length == 0) {
        vm.$message.warning("请先输入手机号码");
        return false;
      } else if (!SysCons.reg.mobile.test(vm.user.mobile)) {
        vm.$message.warning("请输入正确的手机号码");
        return false;
      }
      if ($.trim(vm.user.email).length == 0) {
        vm.$message.warning("邮箱不能为空");
        return false;
      } else if (!SysCons.reg.email.test(vm.user.email)) {
        vm.$message.warning("请输入正确的邮箱");
        return false;
      }
      if ($.trim(vm.user.fullName).length == 0) {
        vm.$message.warning("请先输入真实姓名");
        return false;
      } else if ($.trim(vm.user.fullName).length > 30) {
        vm.$message.warning("姓名不能超过30个字符");
        return false;
      }
      if (vm.user.medicineType === 0) {
        vm.$message.warning("请选择注册类型");
        return false;
      } else if (vm.user.medicineType != 1 && vm.user.medicineType != 2) {
        vm.$message.warning("注册类型错误");
        return false;
      }
      if ($.trim(vm.user.startWorkFormDate).length == 0) {
        vm.$message.warning("请选择开始行医时间");
        return false;
      }
      // 校验手机号码、邮箱地址、account是否可用
      let params = {
        account: vm.user.account,
        mobile: vm.user.mobile,
        email: vm.user.email
      }
      const res = await vm.$ajax.post(SysCons.api.isUsed + '?' + $.param(params))
          .then((res) => {
            if (res.data.message) {
              vm.$message.error(res.data.message);
            }
            return res.data.status;
          })
      if (res != 'success') {
        return false;
      }
      vm.active = 1;
    },
    validate2() {
      let lackNum = 0;
      let vm = this;
      if ($.trim(vm.user.company).length == 0) {
        lackNum++;
        //vm.$message.warning("请先输入单位");
        //return false;
      }
      if ($.trim(vm.user.certNo).length == 0) {
        //vm.$message.warning("请先填写执业证书编号");
        //return false;
        lackNum++;
      }
      if ($.trim(vm.user.certIssuedFormDate).length == 0) {
        // vm.$message.warning("请先选择执业证书发证日期");
        // return false;
        lackNum++;
      }
      if ($.trim(vm.user.certFilePath).length == 0) {
        // vm.$message.warning("请先上传职业证书图片");
        // return false;
        lackNum++;
      }
      if ($.trim(vm.user.licenceNo).length == 0) {
        // vm.$message.warning("请先填写资格证书编号");
        // return false;
        lackNum++;
      }
      if ($.trim(vm.user.licenceIssuedFormDate).length == 0) {
        lackNum++;
        // vm.$message.warning("请先选择资格证书发证日期");
        // return false;
      }
      if ($.trim(vm.user.licenceFilePath).length == 0) {
        // vm.$message.warning("请先上传资格证书图片");
        // return false;
        lackNum++;
      }
      if (lackNum > 0) {
        vm.$messageBox.confirm('还有信息未完善,还要继续吗?', '注册提示', {
          type: 'warning',
          confirmButtonText: '完善信息',
          cancelButtonText: '跳过'
        }).then(() => {
        }).catch(() => {
          vm.active = 2;
          vm.reloadCode('vcode');
        })
      } else {
        vm.active = 2;
        vm.reloadCode('vcode');
      }
    },
    reloadCode(id) {
      this.$ajax.post(SysCons.api.captcha).then((res) => {
        if (res.data.status === 'success') {
          $("img#" + id).attr("src", res.data.data);
          $("img#" + id).attr("key", res.data.token);
        }
      });
    },
    // 上传按钮 限制图片大小
    changeUpload(file, fileList) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!')
        return false
      }

      // 上传成功后将图片地址赋值给裁剪框显示图片
      this.$nextTick(() => {
        this.option.img = URL.createObjectURL(file.raw);
        this.dialogVisible1 = true
      })
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let that = this;
      // 获取截图的base64 数据
      this.$refs.cropper.getCropData((data) => {
        // do something
        this.loading1 = true;
        // 把图片上传到服务器
        setTimeout(() => {
          this.loading1 = false;
          this.dialogVisible1 = false;
          this.fileImg = data;

          let formData = new FormData();

          let arr = data.split(','), mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          formData.append('uploadFile', new File([u8arr], 'test.png', {type: mime}));

          this.$ajax.post(SysCons.headImgUploadUrl, formData)
              .then(function (res) {
                if (res.data.status === 'success') {
                  that.user.headImgPath = res.data.message;
                } else {
                  that.$message.error("头像上传失败");
                }
              }).catch((err) => {
            console.error(err);
            that.$message.error('操作失败');
          })
        }, 1000)
      });
    }
  },
  components: {
    VueCropper
  },
}
</script>

<style scoped lang="scss">
@import '../../assets/css/login.scss';


.login {
  width: auto;
  height: auto;

  .title {
    width: 160px;

    &:before, &:after {
      background: url("~@/assets/img/res_a.png") no-repeat center;
      background-size: cover;
      border: none;
    }

    &:before {
      width: 13px;
      height: 13px;
    }

    &:after {
      width: 10px;
      height: 10px;
    }
  }

  .el-form {
    margin: 20px auto 0;
    width: 90%;
    height: 450px;
    overflow-y: scroll;
    padding-right: 20px;

    .el-form-item {
      margin-bottom: 10px;
    }
  }
}

.leftBG {
  background: url("~@/assets/img/doct_login_bg.png") no-repeat center;
  background-size: cover;
  width: 280px;
}

.right {
  width: 455px;
  padding: 20px;
}

/* 截图 */
/* .cropper-content {} */
.cropper {
  width: auto;
  height: 320px;
}


</style>
